
import { Component, Mixins } from "vue-property-decorator";
import { IColorSpecifiedFeature, Color } from "../../../../../../base/domain/drawing";
import { IPaintStyleOnEditingPropertyEditable, instanceOfIPaintStyleOnEditingPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class PaintStyleOnEditingPropertyEditableMixin extends Mixins() {
  writePropertyWhenValid: (writer: (source: IPaintStyleOnEditingPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IPaintStyleOnEditingPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isPaintStyleOnEditingEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIPaintStyleOnEditingPropertyEditable(s) && s.paintStyleOnEditing().isEditable(), false);
  }

  get paintStyleOnEditing(): IColorSpecifiedFeature {
    return this.readPropertyOrDefault(s => s.paintStyleOnEditing().getValue(), ({isEnable: false, color: new Color("transparent")}));
  }

  set paintStyleOnEditing(value: IColorSpecifiedFeature) {
    this.writePropertyWhenValid(s => s.paintStyleOnEditing().setValue(value));
  }
}
